import gql from 'graphql-tag';

export const START_APPLE_SESSION = gql`
    mutation START_APPLE_SESSION($validationURL: String!, $domainName: String!, $displayName: String!) {
        payments {
            startApplePaySession(validationURL: $validationURL, domainName: $domainName, displayName: $displayName)
        }
    }
`;
